const VISITOR_ID_STORAGE_KEY = 'babychic-visitor-id';

let cachedVisitorId: string | null = null;

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function getVisitorId(): string {
  if (cachedVisitorId) return cachedVisitorId;

  try {
    const stored = localStorage.getItem(VISITOR_ID_STORAGE_KEY);
    if (stored) {
      cachedVisitorId = stored;
      return stored;
    }
  } catch {
  }

  const created = generateUuid();
  cachedVisitorId = created;
  try {
    localStorage.setItem(VISITOR_ID_STORAGE_KEY, created);
  } catch {
  }
  return created;
}
